<template>
  <div class="selection-container">
    <div class="element-detail-row">
      <label class="dropdown-field-label  query-label">
        {{ $t("default") }}
      </label>
      <div class="s-fields">
        <div class="expression-values">
          <div>{{ defaultDateValue }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import utils from "@/utils";

export default {
  name: "DatepickerView",
  props: {
    deId: String,
    appId: String
  },
  computed: {
    ...mapState({
      apps: "apps",
      messages: "messages"
    }),
    de() {
      const currentApp = utils.findAppByAppId(this.apps, this.appId);
      return currentApp.dataElements[this.deId];
    },
    defaultDateValue() {
      if (this.de && this.de.default) {
        return utils.findExpressionLabel(this.de.default);
      }

      return "";
    }
  }
}
</script>

<style scoped>
.s-fields {
  display: inline-block;
  flex-basis: 80%;
}

.dropdown-field-label {
  min-width: 15rem;
}

.query-label {
  font-size: 0.85rem;
  font-weight: bold;
  flex-basis: 15%;
}
.expression-values {
  display: flex;
}
</style>
